import * as React from 'react'
import styled, { css } from 'styled-typed'
import { Trans, useTranslation } from 'translations'

const List = styled.ul`
    padding-left: 1em;
`
const Text = css`
    font-size: 0.875em;
    line-height: 1.75em;
    margin-bottom: 1.5em;
`
const Intro = styled.div`
    ${Text}
`
const ListItem = styled.li`
    ${Text}
`
const Container = styled.div`
    width: 32em;
`
const CardTitle = styled.div`
    font-size: 1.5em;
    margin-bottom: 1em;
`
const CloseLinkWrapper = styled.div`
    width: 100%;
    text-align: center;
    margin-bottom: -1em;
`
const CloseLink = styled.div`
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
`

interface ComparisonGuidelineProps {
    onClose: () => void
}

export function ComparisonGuideline(props: ComparisonGuidelineProps) {
    const { t } = useTranslation()
    return (
        <Container>
            <CardTitle>{t('uiComponents.popups.comparisonGuideline.title')}</CardTitle>
            <Intro>{t('uiComponents.popups.comparisonGuideline.intro')}</Intro>
            <List>
                <ListItem>
                    <Trans i18nKey="uiComponents.popups.comparisonGuideline.yearOverYear" components={{ b: <b /> }} />
                </ListItem>
                <ListItem>
                    <Trans
                        i18nKey="uiComponents.popups.comparisonGuideline.quarterOverQuarter"
                        components={{ b: <b /> }}
                    />
                </ListItem>
                <ListItem>
                    <Trans
                        i18nKey="uiComponents.popups.comparisonGuideline.sprintOverSprint"
                        components={{ b: <b /> }}
                    />
                </ListItem>
            </List>
            <CloseLinkWrapper>
                <CloseLink onClick={props.onClose}>{t('common.close')}</CloseLink>
            </CloseLinkWrapper>
        </Container>
    )
}
